// UID: BWR-IRS_7004_EXT-FILE
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2200
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2347
// Rules are separated by express/non-express loans. However, the rules are the same for both.
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  HasApplicantFiledTR,
  IsBetweenMidAprilMidMay,
  IsBetweenMidAugMidOct,
  IsBetweenMidMayMidAug,
  RulesetResult,
  HasApplicantFiledTRLastYear,
  IsForProfit,
  IsBetweenJanAndMidFeb,
  IsBetweenMidNovAndDec,
  IsBetweenMidOctMidNov,
  IsBusinessEstablishedMoreThan,
} from '../rules';
import IsBetweenMidFebMidApril from '../rules/IsBetweenMidFebMidApril';
import IsBusinessEstablishedEqualTo from '../rules/IsBusinessEstablishedEqualTo';

class TRExtension7004Ruleset implements Ruleset {
  private forProfitResult = (
    data: Partial<ApplicationFormValues>
  ): RulesetResult => {
    const isBetweenJanAndMidFeb = IsBetweenJanAndMidFeb.evaluate(data);
    const isBetweenMidFebMidApril = IsBetweenMidFebMidApril.evaluate(data);
    const isBetweenMidAprilMidMay = IsBetweenMidAprilMidMay.evaluate(data);
    const isBetweenMidMayMidAug = IsBetweenMidMayMidAug.evaluate(data);
    const isBetweenMidAugMidOct = IsBetweenMidAugMidOct.evaluate(data);
    const isBetweenMidOctAndDec = IsBetweenMidOctMidNov.evaluate(data);
    const isBetweenMidNovAndDec = IsBetweenMidNovAndDec.evaluate(data);

    const hasApplicantFiledTRLastYear =
      HasApplicantFiledTRLastYear.evaluate(data);
    const establishedMoreThanZeroYearAgo =
      IsBusinessEstablishedMoreThan.setYears(0).evaluate(data);

    if (
      [
        isBetweenJanAndMidFeb,
        isBetweenMidFebMidApril,
        isBetweenMidOctAndDec,
        isBetweenMidNovAndDec,
      ].some(Boolean)
    )
      return RulesetResult.HIDDEN;

    if (
      [
        isBetweenMidAprilMidMay,
        isBetweenMidMayMidAug,
        isBetweenMidAugMidOct,
      ].some(Boolean) &&
      !hasApplicantFiledTRLastYear &&
      establishedMoreThanZeroYearAgo
    )
      return RulesetResult.REQUIRED;

    return RulesetResult.HIDDEN;
  };

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isForProfit = IsForProfit.evaluate(data);
    if (isForProfit) return this.forProfitResult(data);

    const isBetweenMidAprilAndMidOct = [
      IsBetweenMidAprilMidMay,
      IsBetweenMidMayMidAug,
      IsBetweenMidAugMidOct,
    ].some((Is) => Is.evaluate(data));
    const hasApplicantEverFiledTR = HasApplicantFiledTR.evaluate(data);
    const businessEstablishedTwoYearsAgo =
      IsBusinessEstablishedEqualTo.setYears(2).evaluate(data);
    if (
      !hasApplicantEverFiledTR &&
      isBetweenMidAprilAndMidOct &&
      businessEstablishedTwoYearsAgo
    )
      return RulesetResult.REQUIRED;

    if (
      hasApplicantEverFiledTR &&
      isBetweenMidAprilAndMidOct &&
      !HasApplicantFiledTRLastYear.evaluate(data)
    )
      return RulesetResult.REQUIRED;
    return RulesetResult.HIDDEN;
  };
}

export default new TRExtension7004Ruleset();
